import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "shards-react";
import styled from "styled-components";
import baseUrl from "config/baseUrl";
import Layout from "shared/container/LayoutAdmin";
import ModalEditBanner from "views/BannerSetting/components/ModalEditBanner";
import ModalDeleteBanner from "views/BannerSetting/components/ModalDeleteBanner";
import useToken from "shared/hook/useToken";

const axios = require("axios").default;
const StyledTable = styled.table`
  width: 100%;
  thead {
    height: 60px;
  }
  tbody tr td {
    border-bottom: 1px solid #e5e5e5;
    padding: 20px 0;
  }
`;
const Link = styled.a``;
const BannerSetting = (props) => {
  const { token } = useToken();
  const [openModalBanner, setOpenModalBanener] = useState(false);
  const [openModalDeleteBanner, setOpenModalDeleteBanener] = useState(false);
  const [bannerSettingData, setBannerSettingData] = useState(null);
  const [bannerEditData, setBannerEditData] = useState(null);
  const toggle = () => {
    this.setState({
      open: !this.state.open,
    });
  };
  useEffect(() => {
    if (token) {
      var data = JSON.stringify({
        params: {
          bannerSettingId: "",
        },
        show: 100,
        page: 1,
        orderBy: "bannerSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/bannerlist`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setBannerSettingData(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [openModalBanner, openModalDeleteBanner]);
  return (
    <>
      <Layout>
        <Container>
          <Row>
            <Col>
              <h6>จัดการหน้าหลัก</h6>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <div>การจัดการรูปภาพ Banner หน้าหลัก</div>
              <small>ขนาดรูปภาพที่แนะนำคือ 2736 × 640px โดยต้องเป็น .jpg, .jpeg, .png เท่านั้น</small>
            </Col>
            <Col md="4" className="text-right">
              <Button
                className="btn-white"
                onClick={() => {
                  setOpenModalBanener(true);
                  setBannerEditData(null);
                }}
              >
                + เพิ่มรูปภาพ
              </Button>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col>
              <StyledTable>
                <thead>
                  <tr>
                    <th style={{ width: "70%" }}>รูปภาพ Banner</th>
                    <th style={{ width: "30%" }}>เครื่องมือ</th>
                  </tr>
                </thead>
                <tbody>
                  {bannerSettingData != null &&
                  bannerSettingData.data.length > 0 ? (
                    bannerSettingData.data.map((item, key) => (
                      <tr key={key}>
                        <td>
                          <p>รูปภาพที่ {key + 1}</p>
                          <div className="mb-3">
                            <div style={{marginBottom : '20px'}}>
                              <div>รูปภาพ TH</div>
                              <img
                              src={`${baseUrl}/${item.bannerSettingPic}`}
                              style={{ maxWidth: "600px" }}
                              alt="landdingpage"
                            />
                            </div>
                            <div>
                              <div>รูปภาพ EN</div>
                              <img
                              src={`${baseUrl}/${item.bannerSettingENPic}`}
                              style={{ maxWidth: "600px" }}
                              alt="landdingpage"
                            />
                            </div>
                          </div>
                          <div>
                            <strong>ลิงค์ที่เกี่ยวข้อง:</strong>
                            <Link
                              target="_blank"
                            //   rel="noopener noreferrer"
                              href={`https://${item.bannerSettingLink}`}
                            >
                              {item.bannerSettingLink}
                            </Link>
                          </div>
                        </td>
                        <td>
                          <Button
                            className="btn-white"
                            onClick={() => {
                              setOpenModalBanener(true);
                              setBannerEditData(item);
                            }}
                          >
                            แก้ไขข้อมูล
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="2">ไม่มีข้อมูล Banner</td>
                    </tr>
                  )}
                </tbody>
              </StyledTable>
            </Col>
          </Row>
        </Container>
      </Layout>

      {openModalBanner && (
        <ModalEditBanner
          open={openModalBanner}
          toggle={() => setOpenModalBanener(false)}
          openDelete={() => setOpenModalDeleteBanener(true)}
          data={bannerEditData}
        />
      )}

      {openModalDeleteBanner && (
        <ModalDeleteBanner
          open={openModalDeleteBanner}
          toggle={() => setOpenModalDeleteBanener(false)}
          openEdit={() => setOpenModalBanener(true)}
          data={bannerEditData}
        />
      )}
    </>
  );
};

export default BannerSetting;
